var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconmutuello(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3562 0.119141C11.9125 0.119141 10.6615 0.923047 10.0011 1.97305C9.32439 0.779492 8.11033 0.119141 6.61326 0.119141C5.30896 0.119141 4.29587 0.672851 3.70525 1.47676V0.225781H0.653687V10.1803H3.70525V4.77852C3.70525 3.47422 4.45584 2.76055 5.61248 2.76055C6.77322 2.76055 7.5197 3.47422 7.5197 4.77852V10.1844H10.5508V4.77852C10.5508 3.47422 11.3013 2.76055 12.458 2.76055C13.6187 2.76055 14.3652 3.47422 14.3652 4.77852V10.1844H17.3963V4.36836C17.4086 1.69004 15.8172 0.119141 13.3562 0.119141Z",
    fill: "#0068FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmutuello);
export default __webpack_public_path__ + "static/media/iconmutuello.661d891d731fc36757e032c45377a2a4.svg";
export { ForwardRef as ReactComponent };